import { clsx } from 'clsx';
import Link from 'next/link';

import styles from './Breadcrumbs.module.scss';

import { SvgChevronLeft } from '../../icons/SvgChevronLeft';
import { IClassname } from '../../model/classname';
import { P4 } from '../Typography';

interface IBreadcrumbItem {
  title: string;
  link?: string;
}
interface IBreadcrumbs extends IClassname {
  items: IBreadcrumbItem[];
}
export const Breadcrumbs = ({ items, className }: IBreadcrumbs) => {
  return (
    <nav className={clsx(styles.bread, className)}>
      <ul className={styles.bread__list}>
        {items.map((i, index) => {
          const isLast = index === items.length - 1;
          return (
            <li
              key={i.title}
              className={clsx(
                styles.bread__item,
                isLast && styles['bread__item--last']
              )}
            >
              {i.link ? (
                <Link href={i.link}>
                  <P4>{i.title}</P4>
                </Link>
              ) : (
                <P4>{i.title}</P4>
              )}
              {!isLast ? (
                <SvgChevronLeft className={styles.bread__chevron} />
              ) : null}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
